import React, { useState } from 'react';
import {
  Routes,
  Route,
  Link,
  useLocation
} from "react-router-dom";
import { AnimatePresence } from 'framer-motion';

import './assets/style.scss';
import { Email } from "react-obfuscate-email";
import {
  Offcanvas,
  OffcanvasContainer
} from 'uikit-react';

import Home from './components/Home';
import NoMatch from './components/NoMatch';
import Header from "./components/Header";
import SiteFooter from './components/Footer';

import logo from './assets/images/logo.svg';

const App = () => {
  const location = useLocation();
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useState(defaultDark ? 'dark' : 'light');

  const [menuOpen, setMenuOpen] = useState(false); // menu state

  const switchTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  }

  return (
    <AnimatePresence exitBeforeEnter initial={false}>
      <div className="everything" data-theme={theme}>
        <OffcanvasContainer>

          <Header toggleMenu={toggleMenu} /> {/* pass function as prop */}

          <div className="darkmode" onClick={switchTheme}>
            {theme === 'light' ? '🌑' : '☀️'}
          </div>

          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NoMatch />} />
          </Routes>

          <SiteFooter />

          <Offcanvas id="menu" options="overlay: true" className={menuOpen ? "uk-open" : ""}>
           
          <br/><br/><br/><br/><br/>

            <div className="inner-nav">
              <h5>About</h5>
              <p id="header">
              I'm a design leader helping teams solve complex problems across public experiences, digital products, customer journeys and services. My work combines human-centred design, strategic thinking, and creative direction to deliver solutions that are effective, accessible, and visually engaging. 
              </p>

            
            
              <p>
                <a href="https://www.linkedin.com/in/bamfrd/">LinkedIn ↗</a>
                <br />
               
              </p>
            </div>

            <div className="close-buttom-menu">
              <button className=" uk-button uk-button-primary" onClick={toggleMenu}>Close</button>
            </div>
          </Offcanvas>

        </OffcanvasContainer>
      </div>
    </AnimatePresence>
  );
}

export default App;
